import { tv } from 'tailwind-variants'

export const popperVariants = tv({
  slots: {
    container: 'bg-white shadow-md rounded-mili z-[700] absolute'
  }
})
